module.exports = __webpack_public_path__ + "img/banner-small.7ce70ef7.png";